import React from 'react';
import Landing from './Landing';
import LandingLayout from '../../components/Layout/LandingLayout';

import { getListingFields } from '../../actions/getListingFields';
import messages from '../../locale/messages';
import { getBatch2PageSeo } from '../../helpers/routeSeo';

export default async function action({ store }) {
  const { title, description } = getBatch2PageSeo(
    store,
    messages.batch2HomeMetaTitle,
    messages.batch2HomeMetaDescription,
  );
  const listingFields = store.getState().listingFields.data;

  if (listingFields === undefined) {
    store.dispatch(getListingFields());
  }

  return {
    title,
    description,
    listingFields,
    chunk: 'landing',
    component: (
      <LandingLayout>
        <Landing />
      </LandingLayout>
    ),
  };
};
